import dayjs from 'dayjs';
import { z } from 'zod';

export const ADDON_TYPES: { value: string; label: string }[] = [
    { value: 'academic', label: 'Academic' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'consultant', label: 'Consultant' },
    { value: 'daily', label: 'Daily' },
    { value: 'e365', label: 'E365' },
    { value: 'emergency top ups', label: 'Emergency Top Ups' },
    { value: 'internal', label: 'Internal' },
    { value: 'partner', label: 'Partner' },
    { value: 'overdrafts', label: 'Overdrafts' },
    { value: 'support', label: 'Support' },
    { value: 'training', label: 'Training' },
    { value: 'trial', label: 'Trial' },
    { value: 'sponsorship', label: 'Sponsorship' },
    { value: 'tpa developer', label: 'TPA Developer' },
];

// Accepts an empty string (open-ended addons) or any value dayjs can parse,
// and normalises it to YYYY-MM-DD for the native date inputs and the API.
const dateField = z
    .string()
    .refine((value) => value === '' || dayjs(value).isValid(), { message: 'Invalid date' })
    .transform((value) => (value === '' ? '' : dayjs(value).format('YYYY-MM-DD')));

// Shared field shape + normalisation (date formatting, quantity coercion).
// Kept lenient so existing addons can be loaded into the form even when the
// API returns empty `name`/`type` values, which is legitimate data.
export const addonFormSchema = z.object({
    name: z.string(),
    type: z.string(),
    quantity: z.coerce.number().int().min(0),
    salesforceQuoteNumber: z.string().max(255),
    notes: z.string().max(2000),
    startDate: dateField,
    finishDate: dateField,
});

// Submit-time validation additionally requires a name and type to be chosen.
export const submitAddonSchema = addonFormSchema.extend({
    name: z.string().min(1),
    type: z.string().min(1),
});

export type AddonFormInput = z.input<typeof submitAddonSchema>;
export type AddonFormValues = z.output<typeof submitAddonSchema>;
